module.exports = __webpack_public_path__ + "202408221624/img/home_shop_2.7818600a.png";